import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { themeClasses } from '@member-portal/ui';

interface MapProviderProps {
  children: React.ReactNode;
}

const MapProvider: React.FC<MapProviderProps> = ({ children }) => {
  const apiKey = (import.meta as any).env.VITE_GOOGLE_MAPS_API_KEY || '';

  if (!apiKey) {
    return (
      <div className="flex items-center justify-center h-full bg-theme-bg-secondary border border-theme-border">
        <p className={themeClasses.text.muted}>Map unavailable</p>
      </div>
    );
  }

  return (
    <APIProvider apiKey={apiKey}>
      {children}
    </APIProvider>
  );
};

export default MapProvider;
